/**
 * May this person make Cora write to Lever (live manual screening, live re-run)? Strict: it does
 * not defer to the audit-only RBAC flag, because the proxy enforces CORA_WRITE always.
 */
import { useRBAC } from '../../../../contexts/RBACContext';
import { CORA_WRITE } from '../../permissions';

export function useCoraWrite(): boolean {
  const { permissions, isCoreAdmin } = useRBAC();
  return isCoreAdmin || permissions.has('*') || permissions.has(CORA_WRITE);
}
